import gql from 'graphql-tag'

export const mutation = gql`
mutation updateManyProductsByFilter($byFilter: ProductFilterArgs, $fields: ProductFields!) {
	cashAssist {
		updateManyProducts(byFilter: $byFilter, fields: $fields) {
			id
		}
	}
}`

export default mutation
